import { CONTACT, WHATSAPP } from '../../constants';
import heroBg from '../../assets/seccion-1/Banner1.jpg';
import './hero.css';

function Hero() {
  return (
    <section id="hero" className="hero" style={{ backgroundImage: `linear-gradient(rgba(27,67,50,0.75), rgba(27,67,50,0.85)), url(${heroBg})` }}>
      <div className="container hero__content">
        <span className="hero__badge">Santa Rosa, La Pampa</span>
        <h1 className="hero__title">Limpieza sustentable que funciona de verdad</h1>
        <p className="hero__subtitle">
          Productos eco-friendly, recargables y efectivos para limpiar tu hogar con menos plástico, menos químicos y más conciencia.
        </p>
        <div className="hero__actions">
          <a href={WHATSAPP.url} target="_blank" rel="noreferrer" className="btn btn-whatsapp">
            Armar mi combo por WhatsApp
          </a>
          <a href="#products" className="btn btn-outline">
            Ver productos y usos
          </a>
        </div>
        <p className="hero__location">
          {CONTACT.fullAddress}
        </p>
      </div>
    </section>
  );
}

export default Hero;
